import React, { useEffect, useRef, useState } from "react";
import "./MessageA23.css";

const ITEMS_PER_BATCH = 6;

const MessageA23 = (props) => {
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_BATCH);
  const [revealFrom, setRevealFrom] = useState(null);
  const [hideSeeMore, setHideSeeMore] = useState(false);
  const lastVisibleItemRef = useRef(null);
  const seeMoreButtonRef = useRef(null);

  let listData = { data: [] };

  try {
    listData = JSON.parse(props?.item?.text || "{}");
  } catch (error) {
    console.error("Invalid A23 JSON:", error);
  }

  const items = Array.isArray(listData?.data) ? listData.data : [];
  const shouldShowSeeMore = listData?.seeMore === true;
  const visibleItems = shouldShowSeeMore
    ? items.slice(0, visibleCount)
    : items;
  const hasMoreItems = shouldShowSeeMore && visibleCount < items.length;

  const handleSeeMore = () => {
    setRevealFrom(visibleCount);
    setVisibleCount((currentCount) =>
      Math.min(currentCount + ITEMS_PER_BATCH, items.length)
    );
  };

  useEffect(() => {
    if (revealFrom === null) return undefined;

    const animationFrame = window.requestAnimationFrame(() => {
      const scrollTarget =
        seeMoreButtonRef.current || lastVisibleItemRef.current;

      scrollTarget?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    });

    return () => window.cancelAnimationFrame(animationFrame);
  }, [visibleCount, revealFrom]);

  const handleOptionClick = async (item) => {
    try {
      await props.handleClick(
        props.item.code,
        item.value,
        undefined,
        item.name
      );
    } finally {
      setHideSeeMore(true);
    }
  };

  return (
    <div className="a23-list">
      {visibleItems.map((item, index) => (
        <button
          key={item?.value || index}
          ref={
            index === visibleItems.length - 1 ? lastVisibleItemRef : null
          }
          className={`chat-label action-tab ${
            revealFrom !== null && index >= revealFrom
              ? "a23-option--reveal"
              : ""
          }`}
          id="main-tab1"
          style={{
            color: item?.disabled ? "grey" : undefined,
            borderRadius: "44px",
            animationDelay:
              revealFrom !== null && index >= revealFrom
                ? `${(index - revealFrom) * 60}ms`
                : undefined,
          }}
          disabled={item?.disabled}
          onClick={() => handleOptionClick(item)}
        >
          {item.name}
        </button>
      ))}

      {hasMoreItems && !hideSeeMore && (
        <button
          ref={seeMoreButtonRef}
          type="button"
          className="a23-list-see-more action-tab"
          onClick={handleSeeMore}
        >
          <span>See more</span>
          <span className="a23-list-see-more-icon" aria-hidden="true">
            <svg viewBox="0 0 20 20" focusable="false">
              <path d="m5 7.5 5 5 5-5" />
            </svg>
          </span>
        </button>
      )}
    </div>
  );
};

export default MessageA23;
